import { render, staticRenderFns } from "./UserFormParagraph.vue?vue&type=template&id=1bb0f776&scoped=true&"
import script from "./UserFormParagraph.vue?vue&type=script&lang=js&"
export * from "./UserFormParagraph.vue?vue&type=script&lang=js&"
import style0 from "./UserFormParagraph.vue?vue&type=style&index=0&id=1bb0f776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0f776",
  null
  
)

export default component.exports